// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"NewIssue_jumbotron__1XKVF","textarea":"NewIssue_textarea__30-LQ","backBtn":"NewIssue_backBtn__3IlhE"};